import FirebaseContext from 'contexts/FirebaseContext';
import { useContext } from 'react';

const useFirebase = () => {
  const context = useContext(FirebaseContext);

  if (!context) throw new Error('context must be use inside provider');

  return context;
};

export default useFirebase;
